import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';
import { useRole } from '../hooks/useRole';
import type { UserRole } from '../types/User';
import { roleLevel } from '../utils/roles';

interface ProtectedRouteProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
  requiredRole?: UserRole;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  fallback = <div className="auth-required">Please sign in to access this feature.</div>,
  requiredRole,
}) => {
  const { isAuthenticated, isLoading } = useAuth();
  const { role } = useRole();

  if (isLoading) {
    return <LoadingSpinner fullPage />;
  }

  if (!isAuthenticated) {
    return <>{fallback}</>;
  }

  if (!role) {
    return (
      <div className="auth-required">
        Your account is not authorised to access this app. Contact Oceania to be added.
      </div>
    );
  }

  if (requiredRole) {
    const userLevel = roleLevel(role);
    const requiredLevel = roleLevel(requiredRole);
    if (userLevel < requiredLevel) {
      return (
        <div className="auth-required">
          You need <strong>{requiredRole}</strong> access to view this section.
        </div>
      );
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;
